import { render, staticRenderFns } from "./engleGranger.vue?vue&type=template&id=081deaaa&"
import script from "./engleGranger.vue?vue&type=script&lang=js&"
export * from "./engleGranger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports